require('angular')
require('angular-route')
require('angular-ui-map')
require('ui-cropper')

require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/error-handler/error-handler-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/form/form-module')
require('../components/animate/animate-module')
require('../components/account/account-module')
require('../components/auth/auth-module')
require('../group-event/group-event-module')
require('../group-ranking/group-ranking-module')
require('../group-timeline/group-timeline-module')
require('../group-member/group-member-module')
require('../group-info/group-information-module')

#load Templates
require('./index.jade')
require('./edit.jade')
require('./registration.jade')
require('./detail.jade')
require('./group-detail-toolbar/toolbar.jade')
require('./search.jade')
require('./members.jade')
require('./info.jade')

# Load Css
require('../../../sass/web/html/_group_registration.scss')
require('../../../sass/web/html/_group_list.scss')
require('../../../sass/web/html/_group_detail.scss')
require('../../../sass/web/html/_group_search_item.scss')
require('../../../sass/web/html/_group_members_detail.scss')
require('../../../sass/web/html/_group_info.scss')

GroupRegistrationCtrl = require('./group-registration-controller')
GroupSearchCtrl = require('./group-search-controller')
GroupEditCtrl = require('./group-edit-controller')
GroupListCtrl = require('./group-list-controller')
GroupDetailCtrl = require('./group-detail-controller')
GroupDetailToolbarCtrl = require('./group-detail-toolbar/group-detail-toolbar-controller')
GroupPermissionCtrl = require('./group-permission-controller')
GroupMembersDetailCtrl = require('./group-members-detail-controller')
GroupInformationCtrl = require('./group-information-controller')
GroupDataService = require('./group-data-service')
GroupRegisDataService = require('./group-registration-data-service')
GroupUploadDataService = require('./group-upload-data-service')
GroupDetailToolbarService = require('./group-detail-toolbar/group-detail-toolbar-service')
GroupSearchItemDirective = require('./group-search-item-directive/group-search-item-directive')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-form'
  'gnp-flash'
  'gnp-animate'
  'gnp-error-handler'
  'gnp-app-group-event'
  'gnp-app-group-ranking'
  'gnp-app-group-timeline'
  'gnp-app-group-member'
  'gnp-app-group-info'
  'uiCropper'
]
angular.module 'gnp-app-group', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')

    $routeProvider.when '/groups/registration',
      controller: 'GroupRegistrationCtrl'
      templateUrl: 'web/groups/registration.jade'
      title: '_GROUP.PAGE_TITLE'
      permission:
        signInRequired: true
    $routeProvider.when '/groups/search',
      controller: 'GroupSearchCtrl'
      templateUrl: 'web/groups/search.jade'
      title: '_GROUP.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
    .when '/groups/:id/edit',
      controller: 'GroupEditCtrl'
      templateUrl: 'web/groups/edit.jade'
      title: '_GROUP.EDIT.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        groupInfo: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.getGroup($route.current.params.id)
        ]
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
        groupStatus: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.groupStatus($route.current.params.id)
        ]
    .when '/groups/:id/information',
      controller: 'GroupInformationCtrl'
      templateUrl: 'web/groups/info.jade'
      title: '_GROUP.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        groupInfo: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.getGroup($route.current.params.id)
        ]
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
        groupStatus: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.groupStatus($route.current.params.id)
        ]
    .when '/groups/:id/members',
      controller: 'GroupListMembersCtrl'
      templateUrl: 'web/group-member/list-member.jade'
      title: '_GROUP.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        groupInfo: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.getGroup($route.current.params.id)
        ]
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
    .when '/groups/:id/members/:page',
      controller: 'GroupMembersDetailCtrl'
      templateUrl: 'web/groups/members.jade'
      title: '_GROUP.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        groupInfo: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.getGroup($route.current.params.id)
        ]
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
        groupStatus: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.groupStatus($route.current.params.id)
        ]
    .when '/groups/join',
      controller: 'GroupPermissionCtrl'
      template: ''
      permission:
        signInRequired: true
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
    .when '/groups/:id',
      controller: 'GroupDetailCtrl'
      templateUrl: 'web/groups/detail.jade'
      title: '_GROUP.EDIT.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        groupInfo: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.getGroup($route.current.params.id)
        ]
        groupStatus: ['groupRegisDataService', '$route', (groupRegisDataService ,$route) ->
          groupRegisDataService.groupStatus($route.current.params.id)
        ]
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
    .when '/groups',
      controller: 'GroupListCtrl'
      templateUrl: 'web/groups/index.jade'
      title: '_GROUP.LIST.PAGE_TITLE'
      permission:
        signInRequired: true
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]

  ]
  .factory 'groupDataService', GroupDataService
  .factory 'groupRegisDataService', GroupRegisDataService
  .factory 'groupUploadDataService', GroupUploadDataService
  .factory 'groupDetailToolbarService', GroupDetailToolbarService
  .controller 'GroupRegistrationCtrl', GroupRegistrationCtrl
  .controller 'GroupEditCtrl', GroupEditCtrl
  .controller 'GroupListCtrl', GroupListCtrl
  .controller 'GroupDetailCtrl', GroupDetailCtrl
  .controller 'GroupDetailToolbarCtrl', GroupDetailToolbarCtrl
  .controller 'GroupPermissionCtrl', GroupPermissionCtrl
  .controller 'GroupSearchCtrl', GroupSearchCtrl
  .controller 'GroupMembersDetailCtrl', GroupMembersDetailCtrl
  .controller 'GroupInformationCtrl', GroupInformationCtrl
  .directive 'groupSearchItem' , GroupSearchItemDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-registration-module.coffee